import { Directive, ElementRef, EventEmitter, HostListener, Inject, Input, Output } from '@angular/core';

@Directive({
    selector: '[addClassOnHover]',
})
export class AddClassOnHoverDirective
{
    @Input() addClassOnHover: string = 'className';
    @Output() hoverStateChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
    el: ElementRef;

    constructor(@Inject(ElementRef) el: ElementRef) {
        this.el = el;
    }

    @HostListener('mouseenter') on(): void {
        this.hoverStateChanged.emit(true);

        if (this.el.nativeElement.classList) {
            this.el.nativeElement.classList.add(this.addClassOnHover);
            return;
        }

        this.el.nativeElement.className += this.el.nativeElement.className.length > 0
                ? ' ' + this.addClassOnHover
                : this.addClassOnHover;
    }

    @HostListener('mouseleave') off(): void {
        this.hoverStateChanged.emit(false);

        if (this.el.nativeElement.classList) {
            this.el.nativeElement.classList.remove(this.addClassOnHover);
            return;
        }

        this.el.nativeElement.className = this.el.nativeElement.className.replace(
                new RegExp('(^|\\b)' + this.addClassOnHover + '(\\b|$)', 'gi'),
                ' ',
        );
    }
}
